import React, {useState} from "react";
import {useTranslation} from "react-i18next";
import {Route, Switch, useRouteMatch} from "react-router-dom";

//components:
import MenuComponent from "./MenuComponent";
import UsersPage from "./tab1/UsersPage";
import PendingPage from "./tab2/PendingPage";
import DeactivatedPage from "./tab3/DeactivatedPage";
import InviteModal from "./modals/InviteModal";

const Users = () => {
    const {t} = useTranslation();
    const [showInviteModal, setShowInviteModal] = useState(false);
    let {path} = useRouteMatch();

    return (
        <>
            <div className="col-12 col-md-9 userspage">
                <div className="card card-custom gutter-b shadow">
                    <div className="card-header flex-wrap pt-6 mb-5 border-0">
                        <div className="card-title">{t("ADMINPANEL.USERS.TITLE")}</div>
                        <button className="btn btn-primary" onClick={() => setShowInviteModal(true)}>
                            {t("ADMINPANEL.USERS.NAVBUTTON.INVITE")}
                        </button>
                    </div>
                    <div className="card-body position-relative pt-5">
                        <MenuComponent />

                        <Switch>
                            <Route path={`${path}`} exact>
                                <UsersPage />
                            </Route>
                            <Route path={`${path}/pending`} exact>
                                <PendingPage />
                            </Route>
                            <Route path={`${path}/deactivated`} exact>
                                <DeactivatedPage />
                            </Route>
                        </Switch>
                    </div>
                </div>
            </div>
            <InviteModal showModal={showInviteModal} setShowModal={setShowInviteModal} />
        </>
    );
};

export default Users;
